/** Leaf helpers for React Flow node/edge ids — keep this file free of component imports. */

export const SYNTHETIC_TRIGGER_EDGE_PREFIX = 'synthetic-trigger-edge:';

const TRIGGER_FLOW_NODE_PREFIX = 'trigger:';

/** Flow-node id for a trigger. Triggers aren't workflow nodes, so they're namespaced. */
export function workflowTriggerFlowNodeId(triggerId: string): string {
  return `${TRIGGER_FLOW_NODE_PREFIX}${triggerId}`;
}

export function isSyntheticWorkflowEdgeId(edgeId: string): boolean {
  return edgeId.startsWith(SYNTHETIC_TRIGGER_EDGE_PREFIX);
}

export function isWorkflowTriggerFlowNodeId(nodeId: string): boolean {
  return nodeId.startsWith(TRIGGER_FLOW_NODE_PREFIX);
}
